import { addDays, isBefore } from 'date-fns';

/**
 * Situacao de validade de um documento — CRMC, CNH, CRLV, seguro, vistoria,
 * atestado medico, curso.
 *
 * A JANELA DE AVISO E DE 30 DIAS EM TODO O SISTEMA, e isso e proposital: se cada
 * tela escolhesse a sua, o mesmo veiculo apareceria "em dia" na frota e "vencendo"
 * na ordem de servico, e ninguem saberia qual acreditar.
 *
 * `null` e diferente de `ok`. Documento sem validade informada nao esta em dia — so
 * nao se sabe. Quem chama decide o que fazer com a duvida; aqui ela nao e escondida.
 */
export type SituacaoDeValidade = 'ok' | 'vencendo' | 'vencido' | null;

/** Dias de antecedencia em que um vencimento comeca a avisar. */
export const JANELA_DE_AVISO_EM_DIAS = 30;

export function situacaoDeValidade(
  validade: string | null | undefined,
  janelaEmDias = JANELA_DE_AVISO_EM_DIAS,
): SituacaoDeValidade {
  if (!validade) {
    return null;
  }

  /**
   * Data pura ancorada em meia-noite LOCAL. Sem o `T00:00:00`, `new Date` leria
   * `2026-05-29` como UTC e, em Sao Paulo, um documento que vence hoje apareceria
   * vencido desde ontem (mesmo motivo de nucleo/formato/datas.ts).
   */
  const dia = /^\d{4}-\d{2}-\d{2}$/.test(validade) ? `${validade}T00:00:00` : validade;
  const vencimento = new Date(dia);
  if (Number.isNaN(vencimento.getTime())) {
    return null;
  }

  const hoje = new Date();
  if (isBefore(vencimento, hoje)) {
    return 'vencido';
  }
  if (isBefore(vencimento, addDays(hoje, janelaEmDias))) {
    return 'vencendo';
  }
  return 'ok';
}

/** Vencido OU vencendo dentro da janela. O que pede providencia. */
export function pedeAtencao(validade: string | null | undefined): boolean {
  const situacao = situacaoDeValidade(validade);
  return situacao === 'vencido' || situacao === 'vencendo';
}
